export default __webpack_public_path__ + "static/media/about.522bd86f.jpg";